{
    "CONFIRM": "Confirmation",
    "SURE": "Are you sure you want to leave the screen?",

    "CANCEL": "Cancel",
    "YES": "Yes"
}